import { CHIPS } from '../../constants/game';

export default function Chips({ chips, selected, onSelect }) {
  return (
    <div className="chips">
      {chips.map((x) => (
        <button
          key={x.v}
          className={`chip ${x.c}${x.v === selected ? ' sel' : ''}`}
          onClick={() => onSelect(x.v)}
        >
          <span>{x.v}</span>
        </button>
      ))}
    </div>
  );
}
